/**
 * @file Triggers a browser download of in-memory content as a file.
 */

const AFTER_DOWNLOAD_CLEANUP_DELAY = 4e4; // 40s

const EXTENSION_SEPARATOR = ".";

/**
 * Downloads the given content as a file, optionally with a timestamp added to its name.
 */
const downloadContent = (
  fileName: string,
  content: BlobPart,
  type: string,
  shouldTimestamp = false,
): void => {
  const blob = new Blob([ content ], { type });

  const url = window.URL.createObjectURL(blob);

  let downloadName = fileName;

  if (shouldTimestamp) {
    const timestamp = new Date().getTime();
    const [ extension ] = fileName.split(EXTENSION_SEPARATOR).reverse();

    downloadName = fileName.replace(`.${extension}`, `_${timestamp}.${extension}`);
  }

  const element = document.createElement("a");
  element.setAttribute("hidden", "");
  element.setAttribute("href", url);
  element.setAttribute("download", downloadName);

  document.body.appendChild(element);
  element.click();
  element.remove();

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, AFTER_DOWNLOAD_CLEANUP_DELAY);
};

export default downloadContent;
